import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfidentialityAgreementComponent } from './confidentiality-agreement.component';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { SpinnerModule } from '@app/shared/ui/simple-components/spinner/spinner.module';

@NgModule({
  imports: [CommonModule, ButtonModule, ModalModule, SpinnerModule, TabStripModule],
  declarations: [ConfidentialityAgreementComponent],
  exports: [ConfidentialityAgreementComponent],
})
export class ConfidentialityAgreementModule {}
